var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgF1Serious(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 50,
    viewBox: "0 0 132 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129 21.3774V31.9957C129 41.0395 120.79 47.8629 111.899 46.2088L96.7232 43.3854C93.9855 42.876 92 40.4871 92 37.7024V35.7139C92 29.8089 86.9016 25.1949 81.0259 25.7824L78.7152 26.0135C74.2795 26.4571 71.1232 30.5303 71.801 34.9362C72.0072 36.276 70.6988 37.3447 69.4271 36.8751L51.61 30.2965C46.2219 28.307 40.5 32.2938 40.5 38.0375C40.5 39.5336 39.0681 40.6137 37.6296 40.2027L30.9422 38.292C27.5481 37.3223 23.9091 37.7207 20.8053 39.402L8.76807 45.9221C6.71124 47.0362 4.17981 45.7192 3.91168 43.3954C3.77239 42.1882 4.30694 41.002 5.30356 40.3066L20.6922 29.5704C23.1009 27.8899 25.0313 25.6121 26.294 22.9604L27.6856 20.0381C28.4841 18.3612 30.1079 17.2298 31.9576 17.0617C37.0612 16.5977 41.1828 12.6963 42.0443 7.69965C42.5524 4.75264 45.3257 2.73349 48.2113 3.15321L65.0125 5.59703C66.9091 5.87289 68.8284 5.95927 70.7421 5.85489L86.4277 4.99931C91.8313 4.70457 97.1962 6.06634 101.805 8.90259L109.604 13.7017C112.778 15.6552 116.649 16.1195 120.196 14.9722C124.544 13.5654 129 16.8074 129 21.3774Z",
    stroke: "currentColor",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF1Serious);
export default __webpack_public_path__ + "static/media/f1_serious.30b90b79.svg";
export { ForwardRef as ReactComponent };